exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topmenu-container.el-menu--horizontal>.el-menu-item{float:left;height:50px !important;line-height:50px !important;color:#666666 !important;padding:0 5px !important;margin:0 10px !important;font-size:14px;font-weight:800}.topmenu-container.el-menu--horizontal>.el-menu-item.is-active,.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{border-bottom:2px solid var(--theme) !important;color:#303133}.topmenu-container.el-menu--horizontal>.el-submenu .el-submenu__title{float:left;height:50px !important;line-height:50px !important;color:#999093 !important;padding:0 5px !important;margin:0 10px !important}\n", ""]);

// exports
